export default "__VITE_ASSET__1abRYdL6__"